import React from "react";
import { Route, Routes } from "react-router-dom";
import OnboardingWizard from "./OnboardingWizard";
import { guardElement } from "@comps/components";

// Self-onboarding is reachable by any authenticated user (the axios bearer
// guard already protects it), so it is intentionally NOT gated by an HR modkey.
const OnboardingModules = () => {
  return (
    <Routes>
      <Route path="start" element={guardElement(<OnboardingWizard modkey="onboarding" />, "onboarding")} />
    </Routes>
  );
};

export default OnboardingModules;
